export default __webpack_public_path__ + "static/media/pic1.116f001a.jpg";